import React, { useEffect, useState } from 'react';
import { Card, Form, DatePicker, Select, Button, Table, Tag, Space, InputNumber, message } from 'antd';
import dayjs from 'dayjs';
import api from '../../services/api';

const PERIODO_OPTS = [
  { value: 'MANHA', label: 'Manhã' },
  { value: 'TARDE', label: 'Tarde' },
  { value: 'INTEGRAL', label: 'Integral' },
];
const STATUS_OPTS = [
  { value: 'PRESENTE', label: 'Presente' },
  { value: 'FALTOU', label: 'Faltou' },
  { value: 'JUSTIFICADO', label: 'Justificado' },
];

export default function PresencasPage() {
  const [grupos, setGrupos] = useState([]);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formBusca] = Form.useForm();
  const [formAdd] = Form.useForm();

  useEffect(() => {
    api.get('/creche/grupos').then(res => setGrupos(res.data || []));
  }, []);

  const buscar = async () => {
    try {
      setLoading(true);
      const v = formBusca.getFieldsValue();
      const params = {};
      if (v.grupoId) params.grupoId = v.grupoId;
      if (v.data) params.data = v.data.format('YYYY-MM-DD');
      const res = await api.get('/creche/presencas', { params });
      setList(res.data || []);
    } catch (e) {
      message.error('Erro ao buscar presenças');
    } finally {
      setLoading(false);
    }
  };

  const adicionar = async (values) => {
    try {
      await api.post('/creche/presencas', {
        estudanteId: values.estudanteId,
        data: values.data.format('YYYY-MM-DD'),
        periodo: values.periodo,
        status: values.status,
      });
      message.success('Presença registada');
      buscar();
      formAdd.resetFields();
    } catch (e) {
      message.error('Erro ao registar presença');
    }
  };

  const exportCSV = () => {
    const headers = ['estudanteId', 'data', 'periodo', 'status'];
    const rows = list.map(r => [r.estudanteId, r.data, r.periodo, r.status]);
    const csv = [headers.join(','), ...rows.map(r => r.join(','))].join('\\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `presencas_${dayjs().format('YYYYMMDD_HHmm')}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const columns = [
    { title: 'Estudante', dataIndex: 'estudanteId' },
    { title: 'Data', dataIndex: 'data', render: v => dayjs(v).format('DD/MM/YYYY') },
    { title: 'Período', dataIndex: 'periodo' },
    { title: 'Status', dataIndex: 'status', render: s => <Tag color={s === 'PRESENTE' ? 'green' : s === 'JUSTIFICADO' ? 'blue' : 'red'}>{s}</Tag> },
  ];

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <Card title="Presenças - Consulta">
        <Form layout="inline" form={formBusca} className="mb-4">
          <Form.Item name="data" label="Data" rules={[{ required: true }]}>
            <DatePicker />
          </Form.Item>
          <Form.Item name="grupoId" label="Grupo">
            <Select allowClear style={{ minWidth: 220 }} options={(grupos || []).map(g => ({ value: g.id, label: g.nome }))} />
          </Form.Item>
          <Form.Item>
            <Space>
              <Button type="primary" onClick={buscar} loading={loading}>Buscar</Button>
              <Button onClick={exportCSV} disabled={!list.length}>Exportar CSV</Button>
            </Space>
          </Form.Item>
        </Form>

        <Table rowKey={(r, i) => `${r.estudanteId}-${i}`} dataSource={list} columns={columns} loading={loading} />
      </Card>

      <Card title="Registrar Presença" className="mt-6">
        <Form layout="inline" form={formAdd} onFinish={adicionar}>
          <Form.Item name="estudanteId" label="ID Estudante" rules={[{ required: true }]}>
            <InputNumber min={1} />
          </Form.Item>
          <Form.Item name="data" label="Data" rules={[{ required: true }]}>
            <DatePicker />
          </Form.Item>
          <Form.Item name="periodo" label="Período" rules={[{ required: true }]}>
            <Select style={{ minWidth: 160 }} options={PERIODO_OPTS} />
          </Form.Item>
          <Form.Item name="status" label="Status" rules={[{ required: true }]}>
            <Select style={{ minWidth: 160 }} options={STATUS_OPTS} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">Salvar</Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}
